'use strict';

module.exports = function ($state, departments, dialog, Department, task, $translate) {
    var _this = this;
    this.taskValidated = false;
    this.selectedMembers = [];

    if (task === null) {
        $state.go('dashboard.departments.department.tasks');
    }

    var selectedTimeslot = {
        startDate: null,
        startTime: null,
        endTime: null
    };

    var defaultStartDate = $state.params.date ? new Date($state.params.date) : new Date();
    
    defaultStartDate.setSeconds(0);
    defaultStartDate.setMilliseconds(0);
    defaultStartDate.setHours(defaultStartDate.getHours() + 1);
    defaultStartDate.setMinutes(0);
    var defaultEndDate = new Date(defaultStartDate);
    defaultEndDate.setHours(defaultEndDate.getHours() + 1);

    // defaultStartDate.setSeconds(0);
    // defaultStartDate.setMilliseconds(0);
    // defaultStartDate.setHours(9);
    // defaultStartDate.setMinutes(0);
    // var defaultEndDate = new Date(defaultStartDate);
    // defaultEndDate.setHours(10);

    if (task) {
        //update task data with date objects for manipulation
        task.startDate = new Date(task.startDate);
        task.endDate = new Date(task.endDate);
        if (task.repeatData.repeatTill) {
            task.repeatData.repeatTill = new Date(task.repeatData.repeatTill);
        }
    }

    this.task = task || {
        name: null,
        description: null,
        payload: [],
        payloadHidden: {},
        repeat: false,
        startDate: selectedTimeslot.startDate || defaultStartDate,
        endDate: selectedTimeslot.startDate || defaultEndDate,
        allDay: false,
        repeatData: {
            repeatType: null,
            repeatEnds: null,
            repeatTill: null,
            repeatWeekDays: {},
            repeatMonthDates: [],
            repeatEvery: null
        },
        formId: null,
        clientId: null,
        item : []
    };

    //function to setup the data we send to the server...
    function diffMembers(oldMembers, newMembers) {
        var members = {
            remove: [],
            add: []
        };
        oldMembers = oldMembers.map(function (member) {
            return member.id;
        });
        newMembers = newMembers.map(function (member) {
            return member.id;
        });

        //if the old member is not in the new members list, we mark it for removal
        members.remove = oldMembers.filter(function (memberId) {
            return newMembers.indexOf(memberId) < 0;
        });

        members.add = newMembers.filter(function (memberId) {
            return oldMembers.indexOf(memberId) < 0;
        });

        return members;
    }

    this.deleteTask = function (task) {
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_TASKS.DIAG_DEL.TITLE'),
            body: $translate.instant('DASHBOARD.DASH_TASKS.DIAG_DEL.BODY').concat(task.repeat?$translate.instant('DASHBOARD.DASH_TASKS.DIAG_DEL.BODY_REPEAT'):""),
            accept: $translate.instant('DASHBOARD.DELETE'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(function () {
            return Department.task.destroyById({
                id: $state.params.departmentId,
                fk: task.id
            })
                .$promise;
        })
            .then(function () {
                return $state.reload('dashboard.departments.department.tasks')
                    .then(function () {
                        $state.go('dashboard.departments.department.tasks');
                    });
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.saveTask = function (task, members) {
        if (!_this.taskValidated) {
            return;
        }
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_TASKS.DIAG_SAVE.TITLE'),
            body: $translate.instant('DASHBOARD.DASH_TASKS.DIAG_SAVE.BODY'),
            accept: $translate.instant('DASHBOARD.SAVE'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(function () {
            //we set the payload expected by the server...
            delete task.item;
            delete task.member;
            delete task.client;
            delete task.form;
            var payload = {
                task: task,
                userIds: members.map(function (member) {
                    return member.id;
                })
            };

            //if we have id we use the updateTask endpoint
            if (task.id) {
                return Department.updateTask({
                    departmentId: $state.params.departmentId
                }, payload)
                    .$promise
                    .then(function () {
                        $state.reload('dashboard.departments.department.tasks')
                            .then(function () {
                                $state.go('dashboard.departments.department.tasks');
                            });
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
            //we add a random color to the tasks. From a nice green upwards. avoiding ugly greens.
            var randomColor = Math.floor(Math.random() * 200) + 160;
            task.color = 'hsl(' + randomColor + ',100%,25%)';
            //else we just just the addTask which creates a new one.
            if ($state.template) {
                $state.template.payloadHidden = task.payloadHidden;
                Department.tasktemplate.updateById({
                    id: $state.params.departmentId,
                    fk: $state.template.id
                }, $state.template)
                    .$promise
                    .then(function (template) { }).catch(function (error) { console.log(error); });
            }

            return Department.addTask({
                departmentId: $state.params.departmentId
            }, payload)
                .$promise
                .then(function () {
                    $state.reload('dashboard.departments.department.tasks')
                        .then(function () {
                            $state.go('dashboard.departments.department.tasks');
                        });
                })
                .catch(function (error) {
                    console.log(error);
                });
        });
    };
};